"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const measure_model_1 = require("./measure.model");
class MeasureModelFactory {
    create(path) {
        return new measure_model_1.MeasureModel(path.id, path.currencyId);
    }
}
exports.MeasureModelFactory = MeasureModelFactory;
//# sourceMappingURL=measure-model-factory.js.map